export const isMobile = () => {
    return window.matchMedia("(max-width: 425px)").matches;
  };
  